define('type/article/Serum.NewsArticle',[
  'jquery',
  './Serum.CommentThread',
  'common/js/lib/Serum.Pubsub',
  'common/module/date/Serum.Date',
  'moment',
  './Serum.Article.UniverseRelationDerepetizer',
  './Serum.Article.Note'
], function($, CommentThread, Pubsub, SerumDate, moment, UniverseRelationDerepetizer, Note) {
  'use strict';

  // TODO: move to separate file
  var ExpandableImage = function($element) {

    function toggleFigureSize() {
      var $figure = $(this).parents('figure');
      if (!$figure.hasClass('expanded-figure')) {
        expandFigure($figure);
      } else {
        collapseFigure($figure);
      }
    }

    function collapseFigure($figure) {
      $figure.removeClass('expanded-figure')
        .parent('.col')
        .removeClass('expanded-figure-container');
      $element.attr('title', 'Trykk for å øke størrelsen på bildet');
    }

    function expandFigure($figure) {
      var $container = $figure.parent('.col');

      $figure.addClass('expanded-figure-transition expanded-figure');
      $container.addClass('expanded-figure-transition expanded-figure-container');
      $element.attr('title', 'Trykk for å redusere størrelsen på bildet');
    }

    function handleKeyDown(e) {
      // 13 = enter, 32 = space
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        toggleFigureSize.call(this);
      }
    }

    $element.attr('tabindex', '0');
    $element.attr('role', 'button');
    $element.attr('title', 'Trykk for å øke størrelsen på bildet');
    $element.attr('aria-label', $element.attr('alt'));
    $element.on('click.figurexpansion', toggleFigureSize);
    $element.on('keydown.figurexpansion', handleKeyDown);

    return {
      destroy : function() {
        $element.off('.figurexpansion');
      }
    };
  };

  var NewsArticle = function($element) {
    var selectors = {
      expandableImage : '.g50 > figure.image.rich img',
      imageCaption : '.article-lead-media figcaption',
      relativeDatetime : 'time.datetime-relative[datetime!=""]',
      absoluteDateTime : 'time.datetime-absolute[datetime!=""]',
      updatingArticle : 'p.article-body--updating',
      comments : '.article-comments',
      shareButtons : '.article-share',
      shareToggler : '.article-share__toggle',
      bodyCaption: '.article-body figcaption'
    };
    var classes = {
      toggleShare : 'article-share__toggle--active',
      hiddenShare : 'article-share--hidden'
    };

    function setupComments() {
      $element.find(selectors.comments).each(function(){
        CommentThread.initialize(this);
      });
    }

    function setupCaptionClick() {
      var neverClicked = true;
      $element.on('click.article', selectors.imageCaption, function() {
        $(this).toggleClass('caption-expanded');

        if (neverClicked) {
          neverClicked = false;
          Pubsub.publish(Pubsub.topics.TRACK_EVENT, {
            category : 'Article',
            action : 'Caption click'
          });
        }
      });
    }

    function setupToggleShare() {
      var button = document.querySelector(selectors.shareToggler);
      var toggle = ' ' + classes.toggleShare;

      if (button) {
        button.addEventListener('click', function(){
          button.className = (button.className + toggle).replace(toggle + toggle, '');
        });
      }
    }

    function setupExpandableImages() {

      var images = $element.find(selectors.expandableImage).map(function() {
        return new ExpandableImage($(this));
      });

      $element.on('destroy.article', function() {
        $.each(images, function(i) {
          i.destroy();
        });
      });
    }

    function setupExpandableCaptions(){
      var captions = $element.find(selectors.bodyCaption);

      captions.on('click', function(){
        $(this).toggleClass('caption-expanded');
      })
    }

    function setupShowAllAuthors(){
      document.addEventListener('click', function(event){
        if(event.target.hash === '#authors--expand'){
          event.preventDefault();
          event.target.parentNode.removeChild(event.target);
        }
      });
    }

    // TODO: move this logic elsewhere
    function setupDateline() {
      $element.find(selectors.relativeDatetime).html(function(){
        return new SerumDate(this.getAttribute('datetime')).getHtml();
      });
      $element.find(selectors.absoluteDateTime).html(function(){
        return new SerumDate(this.getAttribute('datetime')).getHtml(true);
      });
    }

    function setupUpdatingArticle() {
      $element.find(selectors.updatingArticle).html(function(){
        var $this = $(this);
        return $this.data('isUpdatingArticle')
            && updatingStillRelevant($this.data('lastUpdated')) ? $this.data('updatingText') : '';
      });
    }

    function updatingStillRelevant(lastUpdated) {
      var now = moment(new Date());
      var lastUpdatedMoment = moment(lastUpdated);
      var duration = moment.duration(now.diff(lastUpdatedMoment));
      return duration.asMinutes() < 60;
    }

    function destroy() {
      $element.trigger('destroy.article');
      $element.off('.article');
    }

    (function initialize() {
      setupComments();
      setupCaptionClick();
      setupExpandableImages();
      setupExpandableCaptions();
      setupToggleShare();
      setupShowAllAuthors();
      setupDateline();
      setupUpdatingArticle();
      UniverseRelationDerepetizer.derepetize($element[0]);
      Note.initialize($element[0]);
    })();

    return {
      destroy : destroy
    };
  };

  return NewsArticle;
});

